import React, { useEffect, useState } from 'react'
import BreadCrames from '../component/BreadCrames'
import { useDispatch } from 'react-redux'
import { sidebarAction } from '../redux/SidebarSlice'
import Loader from '../utils/Loader'
import ApiConnection from '../utils/ApiConnection'
import moment from 'moment'
import { toast } from 'react-toastify'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Earning = () => {
  const [loading, setloading] = useState(false)
    const [dashboarddata, setdashboarddata] = useState([])
    const [startDate, setStartDate] = useState(null);
    const [endDate, setendDate] = useState(null);
    const [TotalFare, setTotalFare] = useState(null);
    const dispatch = useDispatch()




    const Getdata = async (fromdate, todate) =>{

        setloading(true)

        try {

            const response = await ApiConnection.get(`my-earning?from_date=${fromdate}&to_date=${todate}`)
            setloading(false)
            if(response?.status === 200) {
                setdashboarddata(response?.data?.data?.list)

                var Total = 0

                response?.data?.data?.list?.forEach(element => {
                  Total = Total + Number(element?.final_fare)
                });

                setTotalFare(Total)


            }

        } catch (e){ 
           
            setloading(false)}

    }

    useEffect(()=>{
        Getdata('', '')
        dispatch(sidebarAction(false)) 
      },[])

      function SearchHandle(){
        if(startDate == null){
            toast.error("Start date is must")
        } else if(endDate == null){
            toast.error("End date is must")
        } else

        Getdata(moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY'))
    }

    function ClearHandle(){
      Getdata('', '')
        setStartDate(null)
        setendDate(null)
    }




  return (
    <>
    {loading && <Loader/>}
     <BreadCrames page="My Earning" />
     <div className='px-4'>
     <div className="row mb-4">
                          
                     
                        <div className="col-lg-4">
                        <label>From Date:</label>
                            <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" maxDate={new Date()}  placeholderText="From Date" />
                        </div>
                       
                        <div className="col-lg-4">
                        <label>To Date:</label>
                            <DatePicker selected={endDate} onChange={(date) => setendDate(date)} className="form-control" maxDate={new Date()} minDate={startDate}
                                  placeholderText="To Date"
                            />
                        </div>
                        <div className="col-lg-4">
                        <label style={{display:'block'}}>&nbsp;</label>
                            <button className="btn btn-sm btn-primary mr-1" onClick={SearchHandle}>Search</button>
                            <button className="btn btn-sm btn-danger" onClick={ClearHandle}>Clear</button>
                        </div>
                        </div>
                        {dashboarddata?.length > 0 ? 
        <div className='table-responsive'>
            <table className='table'>
            <th>Date</th>
                <th>Pickup Location </th>
                <th>Drop Location </th>
          
                <th>Estimate Fare</th>
                <th>Final Fare</th>
                {dashboarddata?.map((item, i)=>{
                  return (
                    <tr key={i}>
                        <td>{moment(item?.pickup_date).format('DD-MM-YYYY')}</td>
                        <td>{item?.pickup_location}</td>
                        <td>{item?.drop_location}</td>
                      
                        <td>${item?.estimated_fare}</td>
                        <td>${item?.final_fare}</td>
                    </tr>
                  )
                })}
               <tr>
                <td colSpan="4" className='text-right'><b>Total:</b></td>
                <td><b>${TotalFare}.00</b></td>
               </tr>
            </table>
        </div>

        :


        <h5>No Earning history</h5>
              }
       
     </div>
 </>
  )
}

export default Earning